import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NotificationsService } from 'src/app/global-services/notifications.service';
import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
} from '@angular/animations';
import { PlatformInformationService } from 'src/app/global-services/platform-information.service';
import { RegionSelectionService } from 'src/app/global-services/region-selection.service';
import { VersionService } from 'src/app/global-services/version.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/global-services/language.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-universal-header',
  templateUrl: './universal-header.component.html',
  styleUrls: ['./universal-header.component.scss'],
  animations: [
    trigger('wiggle', [
      state(
        'start',
        style({
          opacity: '1',
        })
      ),
      state(
        'end',
        style({
          opacity: '1',
        })
      ),
      transition('start <=> end', [
        animate(
          '3s',
          keyframes([
            style({ transform: 'rotate(0deg) scale(1)' }),
            style({ transform: 'rotate(10deg) scale(1.05)' }),
            style({ transform: 'rotate(-10deg) scale(1.05)' }),
            style({ transform: 'rotate(10deg) scale(1)' }),
            style({ transform: 'rotate(-10deg) scale(1)' }),
            style({ transform: 'rotate(10deg) scale(1.05)' }),
            style({ transform: 'rotate(-10deg) scale(1.05)' }),
            style({ transform: 'rotate(10deg) scale(1)' }),
            style({ transform: 'rotate(-10deg) scale(1)' }),
            style({ transform: 'rotate(10deg) scale(1.05)' }),
            style({ transform: 'rotate(-10deg) scale(1.05)' }),
            style({ transform: 'rotate(10deg) scale(1)' }),
            style({ transform: 'rotate(-10deg) scale(1)' }),
            style({ transform: 'rotate(10deg) scale(1.05)' }),
            style({ transform: 'rotate(-10deg) scale(1.05)' }),
            style({ transform: 'rotate(0deg) scale(1)' }),
          ])
        ),
      ]),
    ]),
  ],
})
export class UniversalHeaderComponent implements OnInit, OnDestroy {
  @Input() title?: string;

  languages = [
    { code: 'pl_PL', name: 'Polski', flagClass: 'fi-pl' },
    { code: 'en_US', name: 'English', flagClass: 'fi-gb' },
    { code: 'pseudo_PL', name: 'Pseudo', flagClass: 'fi-aq' }
  ];

  selectedLanguage: string = 'pl_PL';
  currentFlagClass: string = 'fi-pl';
  private destroy$ = new Subject<void>();

  constructor(
    public regionSelectionService: RegionSelectionService,
    public notificationsService: NotificationsService,
    public platformService: PlatformInformationService,
    public versionService: VersionService,
    private translateService: TranslateService,
    private languageService: LanguageService,
    private router: Router
  ) {}

  ngOnInit() {
    this.updateLanguageFromService();

    // Subscribe to language changes to update the selected language in the dropdown
    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateLanguageFromService();
      });

    // Also listen to router events to catch language changes from URL navigation
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        // Small delay to ensure the language resolver has run
        setTimeout(() => {
          this.updateLanguageFromService();
        }, 100);
      });
  }

  onLanguageChange(event: any) {
    const selectedLang = event.detail.value;
    this.selectedLanguage = selectedLang;
    this.updateFlagClass(selectedLang);
    this.languageService.switchLanguage(selectedLang);
  }

  private updateLanguageFromService() {
    const currentLanguage = this.languageService.getCurrentLanguage();
    if (this.selectedLanguage !== currentLanguage) {
      this.selectedLanguage = currentLanguage;
      this.updateFlagClass(currentLanguage);
    }
  }

  private updateFlagClass(languageCode: string) {
    const language = this.languages.find(lang => lang.code === languageCode);
    if (language) {
      this.currentFlagClass = language.flagClass;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
